import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../app/hooks';
import { fetchInternalSummonAicaData, InternalSummonAicaDataPayload, InternalSummonUserType } from '../../store/user/actions';
import { getPlatformUserId } from '../../utils/utils';

/** Marks a rejection for a responseCode ERROR, which the saga has already toasted. */
export class MagicLinkResponseError extends Error {}

/** Marks a rejection for a request a newer summon dispatch superseded; callers settle quietly. */
export class MagicLinkCancelledError extends Error {}

/** Generates the borrower magic link for an org — same payload the Data Pending GST link uses. */
export function useAssesseeMagicLink() {
    const dispatch = useDispatch();
    const platformData = useAppSelector((state) => state.user.domainMetadata);
    const investorPrimaryEmail = useAppSelector((state) => state.user.userData.investorPrimaryEmail);

    const generate = useCallback(
        (orgId: string): Promise<string> =>
            new Promise((resolve, reject) => {
                const payload: InternalSummonAicaDataPayload = {
                    parentOrgId: platformData?.investorOrgId as string,
                    parentEmailId: investorPrimaryEmail,
                    orgId,
                    userType: InternalSummonUserType.ASSESSEE,
                    requesterUserId: getPlatformUserId(),
                    isMagicLink: true,
                };
                dispatch(
                    fetchInternalSummonAicaData(payload, {
                        onSuccess: (_userData, link) => resolve(`https://${link}`),
                        onError: () => reject(new Error('Failed to fetch the link')),
                        onResponseError: (message) => reject(new MagicLinkResponseError(message)),
                        onCancel: () => reject(new MagicLinkCancelledError('Link request superseded')),
                    }),
                );
            }),
        [dispatch, platformData?.investorOrgId, investorPrimaryEmail],
    );

    return { generate };
}
